import React from 'react'
import * as R from 'ramda'
import { getByType } from 'utils/stuff.js'

import FlatButton from 'material-ui/FlatButton'

export default (o) => (
  <div key={o.id}>
	  {(o.type == 'newProject' || o.type == 'newTask')?
	      <header style={{width: "100%", height: "60px", top: "0", zIndex: "5555", backgroundColor: "#00ACC1", position: "fixed"}}>
	        <div id="close-project-specs" style={{position: "fixed", left: "10px", top: "17px"}}>
	          <img
  				src={'/' + process.env.REACT_APP_NAME + "/static/img/res/menu_delete.png"}
	            style={{width: "28px", cursor: 'pointer'}}
	            onTouchTap={o.closePanel}
	          />
	        </div>
	      </header>
	  :
	      <header style={{width: "100%", height: "60px", top: "0", zIndex: "5555", backgroundColor: "#00ACC1", position: "fixed"}}>
	        <div id="close-project-specs" style={{position: "fixed", left: "10px", top: "17px"}}>
	          <img
	            src={'/' + process.env.REACT_APP_NAME + "/static/img/res/menu_ok.png"}
	            style={{width: "28px", cursor: 'pointer'}}
	            onTouchTap={o.closePanel}
	          />
		  	<span style={{fontSize: "24px", fontFamily: "Verdana", marginTop: "0px", marginLeft: "10px", verticalAlign: 'top'}}>{o.type.toUpperCase()}</span>
			<img
				src={'/' + process.env.REACT_APP_NAME + "/static/img/res/menu_delete.png"}
				style={{width: "26", position: "fixed", right: "10px", top: "18px", cursor: 'pointer'}}
				onClick={() => {
					document.getElementsByClassName('Prompt')[0].style.marginLeft = 0
				}}
			/>
	        </div>
			<div
				style={{
					marginLeft: (o.showPrompt)? "0" : "100%"
				  , position: 'absolute'
				  , marginTop: '-10px'
				  , background: 'rgba(0,0,0,0.8)'
				  , padding: '11px'
				  , transition: 'all ease-in-out 0.3s'
				  , width: '100%'
				  , lineHeight: '40px'
				}}
				className="Prompt"
			>
				<span style={{verticalAlign: 'middle'}}>
					Are you sure you want to delete this item?
				</span>
				<div style={{float: "right"}}>
					<FlatButton
						label="Yes"
						primary={true}
						onClick={()=> {
							if(o.type == 'project'){
								o.deleteFunction(o.id)
							}else if(o.type == 'task'){
								o.updateFunction(o.id)
								o.deleteFunction(o.id)
							}else if(o.type == 'property'){
								o.deleteFunction(o.id)
								R.map((project)=> {
									o.deleteProjectFunction(project._id)
								}, getByType('projects'))
							}else if(o.type == 'tenant'){
								o.deleteFunction(o.id)
							}else if(o.type == 'lease'){
								o.deleteLeaseFunction(o.id)
							}else if(o.type == 'template'){
								o.deleteFunction(o.id)
							}

							o.closePanel()
						}}
					/>
					<FlatButton
						label="No"
						secondary={true}
						onClick={() => {
							document.getElementsByClassName('Prompt')[0].style.marginLeft = "100%"
						}}
					/>
				</div>
			</div>
	      </header>
	  }

		<div style={{
					textAlign: "center"
				  , paddingTop: "80px"
				}}
			>
				<img
					src={'/' + process.env.REACT_APP_NAME + "/static/img/no_bullets.jpg"}
					style={{
						maxWidth: "50%"
					}}
				/>
				<h1>No bullets try to reload</h1>
			</div>
		}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/RightPanel/Panel.js